import { Chart } from '@frontend/chart/types';

export const LENDING_OUTBOUND_PACKAGE_VOLUME_BY_PRODUCT_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'Impact drill', data: [{ label: 'full_period', value: 86 }] },
        { name: 'Torque wrench', data: [{ label: 'full_period', value: 64 }] },
        { name: 'Multimeter', data: [{ label: 'full_period', value: 51 }] },
        { name: 'Laser level', data: [{ label: 'full_period', value: 38 }] },
        { name: 'Heat gun', data: [{ label: 'full_period', value: 27 }] },
        { name: 'Cable tester', data: [{ label: 'full_period', value: 14 }] },
        { name: 'Pipe cutter', data: [{ label: 'full_period', value: 9 }] },
        { name: 'Inspection camera', data: [{ label: 'full_period', value: 3 }] }
    ]
};
